import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

// Get all hero sections
export const getAllHeroSectionsPublic = async () => {
  const response = await api.get('/hero-sections');
  return response.data;
};

// Get hero sections by type
export const getHeroSectionsByTypePublic = async (type) => {
  const response = await api.get(`/hero-sections/type/${type}`);
  return response.data;
};

// Get a single hero section by ID
export const getHeroSectionByIdPublic = async (id) => {
  const response = await api.get(`/hero-sections/${id}`);
  return response.data;
};
